export const MULTI_CHANNEL_DEVICES = new Set<string>(["Teros 54"]);

export const TOWER_NAMES = ["TOWER1", "TOWER2", "TOWER3"] as const;

export function parseTowerId(towerName?: string | null): number | null {
	const match = /^TOWER([1-3])$/.exec(towerName ?? "");
	return match ? Number(match[1]) : null;
}

/** TOWER{n} owns Miro channels 2n-1 (lower inlet) and 2n (upper inlet). */
export function towerChannels(towerId: number): { lower: number; upper: number } {
	return { lower: (towerId - 1) * 2 + 1, upper: (towerId - 1) * 2 + 2 };
}
